import { Endpoints } from "../../../constants/endpoints";
import client from "../../client";
import { TRegisterUser, TAppleSignInBody } from "./types";

export const postAppleSignIn = async (payload: TAppleSignInBody) => {
  const { data } = await client.post<TAppleSignInBody, TRegisterUser>(
    Endpoints.postAppleSignIn,
    {
      ...payload,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};
